module.exports = __webpack_public_path__ + "static/media/mc_open_vector.bf5ea585.svg";